import ServicesComponent from '@components/ServicesComponent';
import SharedConfig from './shared.config';

if (typeof window != 'undefined') {
	if (!(window as any).Components) {
		(window as any).Components = {};
	}
	(window as any).Components[SharedConfig.componentName] = ServicesComponent;
}
